import constant from "../../constant";
import router from "../../router";
const api = constant.api + "expenses";
// initial state
const state = () => ({
  all: [],
  expenses: [],
  expense: {},
});

// getters
const getters = {
  getAll: (state) => {
    return state.all;
  },
  getExpense: (state) => {
    return state.expense;
  },

  getExpenses: (state) => {
    return state.expenses;
  },
};

// actions
const actions = {
  async getAll({ commit }) {
    await this.$api.show(api).then((response) => {
      let expenses = response.data;
      commit("setExpenses", expenses);
    });
  },

  async show({ commit }, reference) {
    await this.$api.show(api + "/" + reference).then((response) => {
      let expense = response.data;
      commit("setExpense", expense);
    });
  },

  async store({ dispatch }, data) {
    await this.$api.create(api, data, { confirm: false }).then((response) => {
      let message = response.data.message;
      let status = response.data.status;
      dispatch("notification/store", { status, message }, { root: true });

      if (status == "success") {
        router.push({
          name: "expenses-index",
        });
      }
    });
  },

  async update({ commit }, data) {
    await this.$api
      .update(api + "/" + data.reference, data)
      .then((response) => {
        let status = response.data.status;
        if (status == "success") {
          router.push({
            name: "expenses-index",
          });
        }
      });
  },

  async togglePaidStatus({ commit }, data) {
    await this.$api
      .update(api + "/" + data.reference, data)
      .then((response) => {
        let status = response.data.status;
        if (status == "success") {
          let data = response.data.data;
          commit("setExpenses", data);
        }
      });
  },

  async destroy({ commit }, reference) {
    await this.$api
      .delete(api + "/" + reference)
      .then((response) => {
        let status = response.data.status;
        if (status == "success") {
          let data = response.data.data;
          commit("setExpenses", data);
        }
      });
  },
};

// mutations
const mutations = {
  setExpenses(state, expenses) {
    state.all = expenses;
    state.expenses = expenses;
  },
  setExpensesPrices(state, expenses) {
    state.all = expenses;
    state.expenses = expenses;
  },
  setExpense(state, expense) {
    state.expense = expense;
  },
  async search(state, value) {
    value = value.charAt(0).toUpperCase() + value.slice(1);
    console.log(value);
    state.expenses = state.all.filter(function (expense) {
      return (
        expense.firstName.toUpperCase().indexOf(value.toUpperCase()) > -1 ||
        expense.lastName.toUpperCase().indexOf(value.toUpperCase()) > -1 ||
        expense.phone.toUpperCase().indexOf(value.toUpperCase()) > -1 ||
        expense.reference.toUpperCase().indexOf(value.toUpperCase()) > -1
      );
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
